// /account opens Account's first section, the Profile (A12U24: `/account/<section>`); the catalogue keeps /account as
// the link path the apps open.
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/account/')({
  beforeLoad: () => {
    throw redirect({ to: '/account/profile', replace: true })
  },
})
